<app-atom-model-counter
	[label]="'counter-label-report' | translate"
	[customClass]="'counter-report'"
	[loading]="loading"
	[count]="count"
	[iconTpl]="iconTpl"
	[linkFullList]="['/report/list']"
></app-atom-model-counter>

<ng-template #iconTpl>
	<i nz-icon nzType="line-chart" nzTheme="outline"></i>
</ng-template>
